// eslint-disable-next-line import/no-unresolved
import { linkedInIndustries } from '@albacross/static-data/lib/linkedin-industries'

const findIndustryByQuery = (query, linkedInIndustries) =>
  linkedInIndustries.filter(industry => new RegExp(query, 'i').test(Object.values(industry).join('')))

const getIndustryByCode = (val, linkedInIndustries) => linkedInIndustries.find(({ code }) => code === parseInt(val, 10))

const findIndustries = ({ search, code }: any = {}) => {
  return code ? getIndustryByCode(code, linkedInIndustries) : findIndustryByQuery(search, linkedInIndustries)
}

const reduceIndustriesIntoMap = industries =>
  industries.reduce((acc, item) => acc.set(item.code.toString(), item), new Map())

export const getLinkedInIndustryMap = () => {
  const linkedInIndustries = findIndustries()
  return reduceIndustriesIntoMap(linkedInIndustries)
}

export const findLinkedInIndustryByCode = code => {
  const found = findIndustries({ code })
  return found
}

export const filterLinkedInIndustryByCode = (code, industries) => industries.get(code)
